// extracted by mini-css-extract-plugin
var _1 = "UserUsernameEditStep_text__f3-Bg";
export { _1 as "text" }
